export const SET_LANGUAGE = "SET_LANGUAGE"

export const setLangAction = (id)=>{
    return{
        type: SET_LANGUAGE,
        language_id: id
    }
}